import { render, staticRenderFns } from "./IndexHeader.vue?vue&type=template&id=64e5461c&scoped=true&"
import script from "./IndexHeader.vue?vue&type=script&lang=js&"
export * from "./IndexHeader.vue?vue&type=script&lang=js&"
import style0 from "./IndexHeader.vue?vue&type=style&index=0&id=64e5461c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e5461c",
  null
  
)

export default component.exports